module.exports = __webpack_public_path__ + "img/Contact-icon-1.46a1ea85.svg";